// Bare /liff/sites entry — registered LIFF endpoint URL for site_live.
// LINE redirects users without a specific siteId here. We init LIFF (so the
// SDK is happy and "LIFF Load failed" doesn't trigger), then show a picker.

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLiff } from "../../../liff/index.js";
import { fetchManagerToday, type ManagerTodayData } from "../../../liff/api.js";
import { MobileShell, Card, CardHeader, MobileSpinner, EmptyMobile } from "../../../liff/components/Mobile.js";

export function SitePickerPage(): React.ReactElement {
  const { session } = useLiff();
  const nav = useNavigate();
  const [data, setData] = useState<ManagerTodayData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!session) return;
    fetchManagerToday(session.tenant_id, session.session_token)
      .then(setData)
      .catch((e: unknown) => setError((e as Error).message));
  }, [session]);

  if (error) return (
    <MobileShell title="無法載入案場列表"><Card><p className="text-sm text-danger">{error}</p></Card></MobileShell>
  );
  if (!data) return <MobileSpinner />;
  return (
    <MobileShell title="選擇案場" subtitle="點選一個案場以查看即時狀態">
      <Card>
        <CardHeader title="今日案場" hint={`${data.sites.length} 筆`} />
        {data.sites.length === 0 ? (
          <EmptyMobile title="沒有可進入的案場" />
        ) : (
          <ul className="divide-y divide-border-subtle -my-2">
            {data.sites.map((s) => (
              <li key={s.site_id}>
                <button
                  onClick={() => nav(`/liff/sites/${encodeURIComponent(s.site_id)}/live`)}
                  className="w-full text-left py-3 flex items-center justify-between gap-2"
                >
                  <div className="min-w-0">
                    <p className="text-sm font-medium truncate">{s.site_name}</p>
                    <p className="text-[11px] text-text-muted">完成率 {Math.round(s.completion_rate * 100)}% · 漏巡 {s.overdue_count} · 風險 {s.risk}</p>
                  </div>
                  <span className="text-text-muted text-xs">→</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </MobileShell>
  );
}
